import styled from "styled-components";

export const ErrorMessage = styled.div`
  border-left: 4px solid red;
  margin: 8px 0;
  color: red;
  padding: 2px 6px;
`;